module.exports = __webpack_public_path__ + "img/Aptamil_IF_1_1200g_062022_front_left-removebg-preview_1.ac4bb05f.png";